import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  CPD_POINTS: {
    GET_EXPORT: (query, mockUserId) => ({ query, mockUserId }),
    API: {
      GET_EXPORT: apiResourceActionCreator('cpdPoints')
    }
  }
})

export const apiAction = (authToken, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}${endpointQuery({ ...(query || {}) })}`, authToken, action.cpdPoints.api.getExport)

function* getExport(action) {
  const authToken = yield select(authTokenSelector);
  const { query, mockUserId } = action.payload;
  yield put(apiAction(
    mockUserId !== undefined ? { ...authToken, mockUserId } : authToken,
    query
  ));
}

const configuration = {
  name: 'getExport',
  action: action,
  sagas: getExport,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true,
      exportCpdPoints: undefined
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      exportCpdPoints: action.payload.cpdPoints.userCpdPoints,
      totalCpdActivityCount: action.payload.cpdPoints.total,
      filterHits: action.payload.cpdPoints.hits
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/cpd-points/configurations/getExport.js